import { Genre } from "./Genre";

export class GenreHelper {
    static genres: Genre[] = [
        new Genre("Summer", "../../assets/img/moods & genres/summer.png"),
        new Genre("Pop", "../../assets/img/moods & genres/pop.png"),
        new Genre("Mood", "../../assets/img/moods & genres/mood.png"),
        new Genre("Party", "../../assets/img/moods & genres/party.png"),
        new Genre("Hip-Hop", "../../assets/img/moods & genres/hip-hop.png"),
        new Genre("Chill", "../../assets/img/moods & genres/chill.png"),
        new Genre("Decades", "../../assets/img/moods & genres/decades.png"),
        new Genre("Electronic Dance", "../../assets/img/moods & genres/electronic-dance.png"),
        new Genre("R'n'B", "../../assets/img/moods & genres/rnb.png"),
        new Genre("Indie", "../../assets/img/moods & genres/indie.png"),
        new Genre("Workout", "../../assets/img/moods & genres/workout.png"),
        new Genre("Rock", "../../assets/img/moods & genres/rock.png"),
        new Genre("Pride", "../../assets/img/moods & genres/pride.png"),
        new Genre("Focus", "../../assets/img/moods & genres/focus.png"),
        new Genre("Sleep", "../../assets/img/moods & genres/sleep.png"),
        new Genre("Country", "../../assets/img/moods & genres/country.png"),
        new Genre("Folk Americana", "../../assets/img/moods & genres/folk-americana.png"),
        new Genre("Romance", "../../assets/img/moods & genres/romance.png"),
        new Genre("Trending", "../../assets/img/moods & genres/trending.png"),
        new Genre("Gaming", "../../assets/img/moods & genres/gaming.png"),
        new Genre("Jazz", "../../assets/img/moods & genres/jazz.png"),
        new Genre("Comedy", "../../assets/img/moods & genres/comedy.png"),
        new Genre("Soul", "../../assets/img/moods & genres/soul.png"),
        new Genre("Classical", "../../assets/img/moods & genres/classical.png"),
        new Genre("Kids", "../../assets/img/moods & genres/kids.png"),
        new Genre("Travel", "../../assets/img/moods & genres/travel.png"),
        new Genre("K-Pop", "../../assets/img/moods & genres/k-pop.png"),
        new Genre("Reggae", "../../assets/img/moods & genres/reggae.png"),
        new Genre("Metal", "../../assets/img/moods & genres/metal.png"),
        new Genre("Punk", "../../assets/img/moods & genres/punk.png"),
        new Genre("Blues", "../../assets/img/moods & genres/blues.png"),
        new Genre("Fresh Finds", "../../assets/img/moods & genres/fresh-finds.png"),
        new Genre("Running", "../../assets/img/moods & genres/running.png"),
        new Genre("Word", "../../assets/img/moods & genres/word.png"),
        new Genre("Dinner", "../../assets/img/moods & genres/dinner.png"),
        new Genre("Latin", "../../assets/img/moods & genres/latin.png"),
        new Genre("Funk", "../../assets/img/moods & genres/funk.png")
      ];
}
